import React, { useState } from 'react';
import { Container, Row, Col, Form } from 'react-bootstrap';
import { Link, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { expressURL } from '../../utils/networkUtils';
import { newPasswordKdf, derivePasswordKeys } from '../../crypto/passwordSplit.ts';
import { wrapPrivateKeyWithWrapKey } from '../../crypto/identity.ts';

function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState(token ? '' : 'This reset link is missing. Ask for a new one.');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const kdf = newPasswordKdf();
      const keys = await derivePasswordKeys(password, kdf);
      const wrapped = await wrapPrivateKeyWithWrapKey(keys.wrapKey);
      const response = await axios.post(`${expressURL()}/auth/reset-password`, {
        token,
        password: keys.authKey,
        passwordKdf: kdf,
        publicKeyJwk: wrapped.identity.publicKeyJwk,
        wrappedPrivateKey: wrapped.wrappedPrivateKey
      });
      setMessage(typeof response.data === 'string' ? response.data : 'Password updated. You can log in now.');
    } catch (error) {
      const detail = error.response?.data;
      const text = typeof detail === 'string' ? detail : (detail?.error || error.message || 'unknown error');
      setMessage('Error: ' + text);
    }
  };

  return (
    <div className='main-content'>
      <Container className='mb-5'>
        <h1 className="display-4 mb-3 mt-3">New password</h1>
        <p className="text-muted">This replaces chat keys on the account. Old encrypted threads need Shamir shares to recover.</p>
        <form onSubmit={handleSubmit}>
          <Row>
            <Col sm={3} md={2} xxl={1}>
              <Form.Label>New password</Form.Label>
            </Col>
            <Col className='mb-3'>
              <Form.Control
                type="password"
                autoComplete="new-password"
                name="new-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                disabled={!token}
              />
            </Col>
          </Row>
          <button className='btn btn-primary' type="submit" disabled={!token}>Save password</button>
        </form>
        {message && <p className="mt-3">{message}</p>}
        <p className="mt-3"><Link to="/login">Back to login</Link></p>
      </Container>
    </div>
  );
}

export default ResetPassword;
